import { render, staticRenderFns } from "./ThemeImg.vue?vue&type=template&id=5fe2c2e2&"
import script from "./ThemeImg.vue?vue&type=script&lang=ts&"
export * from "./ThemeImg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports